export const spotlightProductsQueryParam = 'products';
export const spotlightProductsCallbackQueryParam = 'spotlightProducts';
